import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

// Ürün kopyalama — reçete (BOM) + varyantlar dahil.
// Products listesi ve Ürün Detay sayfası ortak kullanır (tek canonical akış).
export async function duplicateProduct(p) {
  const newName = window.prompt(
    `"${p.name}" kopyalanacak. Yeni ürün adı:`,
    `${p.name} (Kopya)`,
  );
  if (!newName || !newName.trim()) return null;
  try {
    // Kaynak ürünü tam detayla al
    const { data: src } = await api.get(`/products/${p.id}`);
    const body = {
      name: newName.trim(),
      code: `${src.code || ""}-COPY-${Date.now().toString(36).slice(-4)}`.toUpperCase(),
      brand: src.brand || "",
      category: src.category || "",
      description: src.description || "",
      images: src.images || [],
      specifications: src.specifications || {},
    };
    const { data: created } = await api.post("/products", body);
    // Reçeteyi (BOM) de kopyala — backend her satır için PUT/POST'ta gerekli
    // alanları bekliyor; GET'ten dönen doldurma alanlarını olduğu gibi
    // gönderiyoruz (fabric_id, consumption_per_unit, qty_per_unit, department vs.)
    try {
      const { data: bom } = await api.get(`/products/${p.id}/bom`);
      const hasContent =
        (bom.fabric_lines || []).length > 0 ||
        (bom.accessory_lines || []).length > 0 ||
        (bom.operation_lines || []).length > 0;
      if (hasContent) {
        await api.put(`/products/${created.id}/bom`, {
          fabric_lines: (bom.fabric_lines || []).map((l) => ({
            fabric_id: l.fabric_id,
            fabric_name: l.fabric_name || "",
            fabric_code: l.fabric_code || "",
            consumption_per_unit: l.consumption_per_unit || 0,
            unit: l.unit || "kg",
            unit_cost: l.unit_cost || 0,
          })),
          accessory_lines: (bom.accessory_lines || []).map((l) => ({
            accessory_id: l.accessory_id,
            accessory_name: l.accessory_name || "",
            accessory_code: l.accessory_code || "",
            qty_per_unit: l.qty_per_unit || 0,
            unit: l.unit || "adet",
            unit_cost: l.unit_cost || 0,
          })),
          operation_lines: (bom.operation_lines || []).map((l) => ({
            operation_id: l.operation_id || "",
            name: l.name,
            department: l.department || "dikim",
            minutes_per_unit: l.minutes_per_unit || 0,
            cost_per_minute: l.cost_per_minute || 0,
            notes: l.notes || "",
          })),
          overhead_percent: bom.overhead_percent ?? 15,
          target_margin_percent: bom.target_margin_percent ?? 30,
        });
      }
    } catch (bomErr) {
      console.warn("BOM copy failed:", bomErr?.response?.data || bomErr);
      toast.error("Reçete kopyalanamadı: " + formatApiError(bomErr));
    }
    // Varyantları da kopyala (varsa) — stok 0 başlar; SKU backend'in
    // otomatik üretimine bırakılır, barkod mevcut "generate-barcodes"
    // mekanizmasıyla yeni ve benzersiz üretilir (kaynakta barkod varsa).
    try {
      const { data: variants } = await api.get(`/products/${p.id}/variants`);
      const srcHadBarcode = (variants || []).some((v) => (v.barcode || "").trim());
      let copiedCount = 0;
      for (const v of (variants || []).slice(0, 200)) {
        const vb = {
          sku: "",
          barcode: "",
          attributes: v.attributes || {},
          sales_price: v.sales_price || 0,
          stock_qty: 0,
        };
        try {
          await api.post(`/products/${created.id}/variants`, vb);
          copiedCount++;
        } catch { /* tekil varyant hatası — atla */ }
      }
      if (copiedCount > 0 && srcHadBarcode) {
        try { await api.post(`/products/${created.id}/variants/generate-barcodes`); } catch { /* barkod üretimi atla */ }
      }
    } catch (varErr) {
      console.warn("Variant copy failed:", varErr?.response?.data || varErr);
      toast.error("Varyantlar kopyalanamadı: " + formatApiError(varErr));
    }
    toast.success(`"${newName}" oluşturuldu`);
    return created;
  } catch (e) { toast.error(formatApiError(e)); return null; }
}
